module.exports = __webpack_public_path__ + "static/media/ic-laptop.0afc280c.svg";